export default {unions:{EntryNode:{spreads:{EntrySummary:{}}},InaccessibleInfoNode:{spreads:{InaccessibleInfo:{}}}}}